// A Try it guest's session in the app (TOM-868, cloud ADR 0419).
//
// <DemoLeaseWatcher> sends a guest whose lease ended to /try, with a note. api()
// raises the event when a guest's request gets 401 after renewal failed.
// <GuestBlocked> stands in for a page a guest cannot use at all.

import { useEffect, type ReactNode } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useAuth, useDemoGuest } from '../auth';
import { DEMO_ENDED_EVENT } from '../lib/demo';

export function DemoLeaseWatcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const onTry = location.pathname === '/try';

  useEffect(() => {
    const onEnded = () => {
      if (onTry) return;
      navigate('/try', { replace: true, state: { ended: true } });
      // The session is gone: read it again, so the app stops showing the guest.
      void refresh();
    };
    window.addEventListener(DEMO_ENDED_EVENT, onEnded);
    return () => window.removeEventListener(DEMO_ENDED_EVENT, onEnded);
  }, [navigate, refresh, onTry]);

  return null;
}

/** A page a Try it guest cannot use: a short note in its place. */
export function GuestBlocked({ children }: { children: ReactNode }) {
  const guest = useDemoGuest();
  if (!guest) return <>{children}</>;
  return (
    <section className="dashboard" data-testid="demo-blocked">
      <header className="dashboard-head">
        <h2>Not available in the demo</h2>
        <p className="dashboard-sub">
          This page changes an account, a device or the boat itself, so the demo leaves it out.
        </p>
      </header>
      <p>
        <Link to="/dashboard">Back to the demo boat</Link>
      </p>
    </section>
  );
}
